// extracted by mini-css-extract-plugin
export default {"heru":"Heru_heru__ZGQJ6","imageCont":"Heru_imageCont__y9C3F"};